import type { AmbassadorResponse } from '../../api/earnings/ambassador'

type Props = {
  status: AmbassadorResponse['status']
}

export default function AmbassadorStatusCard({ status }: Props) {
  const reqScore = status.next_tier?.requirements.reputation_score ?? status.reputation_score
  const progress = Math.max(0, Math.min(100, reqScore <= 0 ? 100 : Math.round((status.reputation_score / reqScore) * 100)))

  return (
    <section className="rounded-2xl border border-white/10 bg-white/5 p-5">
      <h2 className="text-lg font-bold">Your Ambassador Status</h2>
      {!status.is_eligible ? (
        <div className="mt-3 rounded-xl border border-amber-300/30 bg-amber-500/10 p-3 text-sm text-amber-100">
          Earnings paused: {status.ineligible_reason === 'inactive' ? 'Inactive last 30 days' : 'Reputation below threshold'}.
          <a href="/publish" className="ml-1 underline">Post something</a>
        </div>
      ) : null}
      <div className="mt-3 flex flex-wrap items-center gap-2 text-sm">
        <span className="rounded-full border border-cyan-300/35 bg-cyan-500/15 px-3 py-1 font-semibold text-cyan-100">{status.tier}</span>
        <span className="text-white/70">Reputation: {status.reputation_score}</span>
        <span className={`rounded-full px-2 py-0.5 text-xs ${status.is_eligible ? 'bg-emerald-500/15 text-emerald-200' : 'bg-white/10 text-white/70'}`}>
          {status.is_eligible ? 'Active this month' : 'Inactive'}
        </span>
      </div>
      <div className="mt-3 text-xs text-white/65">
        {status.next_tier
          ? `Next tier: ${status.next_tier.tier} at reputation ${status.next_tier.requirements.reputation_score}`
          : 'Top tier reached'}
      </div>
      <div className="mt-2 h-2 rounded-full bg-white/10">
        <div className="h-2 rounded-full bg-cyan-400" style={{ width: `${progress}%` }} />
      </div>
      {Array.isArray((status as any).eligibility_checks) && (status as any).eligibility_checks.length > 0 ? (
        <div className="mt-4 rounded-xl border border-white/10 bg-black/30 p-3">
          <div className="text-xs font-semibold uppercase tracking-wide text-white/60">Eligibility checklist</div>
          <ul className="mt-2 space-y-1.5 text-sm">
            {(status as any).eligibility_checks.map((check: any, idx: number) => (
              <li key={`${check?.label || 'check'}-${idx}`} className="flex items-start gap-2">
                <span className={`mt-0.5 inline-flex h-4 w-4 items-center justify-center rounded-full text-[10px] ${check?.ok ? 'bg-emerald-500/20 text-emerald-200' : 'bg-amber-500/20 text-amber-200'}`}>
                  {check?.ok ? 'OK' : '!'}
                </span>
                <div>
                  <div className={`${check?.ok ? 'text-white/85' : 'text-amber-100'}`}>{check?.label || 'Requirement'}</div>
                  <div className="text-xs text-white/60">{check?.detail || ''}</div>
                </div>
              </li>
            ))}
          </ul>
        </div>
      ) : null}
    </section>
  )
}
